import React from 'react';
import { Card, Form, Input, Select, Row, Spin, Col } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Prompt } from 'dva/router';
import { ButtonBar } from '../../../../components';

import styles from '../../styles.less';

const FormItem = Form.Item;

class CompanyItem extends React.Component {
  constructor(props) {
    super(props);
    this.projectId = this.props.match.params.projectId;
    this.companyId = this.props.match.params.companyId || null;
    this.state = {
      leadMarks: [],
      isSubmitted: false,
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: this.companyId ?
          'Component.Company.Item.EditTitle' :
          'Component.Company.Item.AddTitle',
      },
    });

    this.reloadList();
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      const projectId = this.projectId;
      const companyId = this.companyId;

      if (!err) {
        this.setState({ isSubmitted: true });
        this.props.dispatch({
          type: this.companyId ? 'companies/update' : 'companies/create',
          payload: {
            projectId,
            companyId,
            ...values,
          },
        }).then(
          response => response && response.success && this.props.modal && this.props.onSubmit(),
        );
      }
    });
  }

  filterAttributes(inputValue, option) {
    return option.props.children.toLowerCase().startsWith(inputValue.toLowerCase());
  }

  cancelAction() {
    this.props.dispatch({
      type: 'app/goToRoute',
      payload: {
        routeName: 'COMPANIES_LIST',
        projectId: this.projectId,
      },
    });
  }

  reloadList() {
    const companyId = this.companyId;
    const projectId = this.projectId;

    if (companyId) {
      this.props.dispatch({
        type: 'companies/companyDetail',
        payload: {
          projectId,
          companyId,
        },
      }).then((data) => {
        const leadMarks = data.lead_marks.map((item) => {
          return item.id;
        });
        this.setState({ leadMarks });
      });
    }

    this.props.dispatch({ type: 'leadLabels/loadList', payload: { projectId } });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { company } = this.props.companies;
    const leadLabels = this.props.leadLabels.leadLabelsList || [];
    const showMask = !!this.props.loading.effects['companies/create'] ||
      !!this.props.loading.effects['companies/update'] ||
      !!this.props.loading.effects['companies/companyDetail'];

    return (
      <div>
        <Prompt
          when={this.props.form.isFieldsTouched() && !this.state.isSubmitted}
          message={this.props.intl.locale}
        />
        <Spin
          spinning={showMask}
          className={styles.companySpinContainer}
        >
          <div className={[styles.containerLarge].join(' ')}>
            <Form onSubmit={this.handleSubmit.bind(this)} className={styles.newForm}>
              <Card>
                <Row type="flex" gutter={32}>
                  <Col span={24}>
                    <FormItem label={<FormattedMessage id="Component.Company.Item.Name" />} className={styles.companyNewNameInput}>
                      {getFieldDecorator('name', {
                        rules: [{
                          required: true,
                          message: this.props.intl.formatMessage({ id: 'Common.Field.Required' }),
                        }],
                        initialValue: this.companyId ? company.name : null,
                      })(
                        <Input maxLength={255} disabled={!!this.companyId} />,
                      )}
                    </FormItem>
                  </Col>
                </Row>
                <Row type="flex" gutter={32}>
                  <Col span={24}>
                    <FormItem label={<FormattedMessage id="Component.Company.Item.LeadLabel" />} className={styles.leadLabelNewSelect}>
                      {getFieldDecorator('lead_marks', {
                        initialValue: this.state.leadMarks,
                        maxLength: 255,
                        minLength: 3,
                      })(
                        <Select style={{ width: '100%' }} mode="multiple" showArrow filterOption={this.filterAttributes.bind(this)}>
                          {leadLabels.map(
                            c => <Select.Option key={c.id} value={c.id}>{c.name}</Select.Option>,
                          )}
                        </Select>,
                      )}
                    </FormItem>
                  </Col>
                </Row>
                <Row type="flex" gutter={32}>
                  <Col span={24}>
                    <FormItem label={<FormattedMessage id="Component.Company.Item.CustomerNumber" />}>
                      {getFieldDecorator('customer_number', {
                        rules: [{
                          required: false,
                          message: this.props.intl.formatMessage({ id: 'Common.Field.Required' }),
                          maxLength: 255,
                        }],
                        initialValue: this.companyId ? company.customer_number : '',
                      })(
                        <Input maxLength={255} />,
                      )}
                    </FormItem>
                  </Col>
                </Row>
              </Card>
              <ButtonBar
                cancelAction={this.cancelAction.bind(this)}
              />
            </Form>
          </div>
        </Spin>
      </div>
    );
  }
}

export default connect(({
  loading,
  companies,
  app,
  leadLabels,
}) => ({
  loading,
  companies,
  app,
  leadLabels,
}))(Form.create()(injectIntl(CompanyItem)));



// WEBPACK FOOTER //
// ./src/components/Companies/CompaniesOverview/CompanyItem/CompanyItem.js